import store from '@sb/store'
import Event from './Event.js'
import PoweredBy from './PoweredBy.js'
const convoemptyimg = require('../../assets/img/convos_empty.svg')
var sb = require('@sb/util')

export default {
	name: 'events',
	props: ['cid', 'creating'],
	data () {
		return {
			loading: false,
			error: false,
		}
	},

	created () {
		store.onUpdate(this, _ => this.$forceUpdate())
		store.onConvoEvent(this, ev => this.onEvent(ev))
		this.loadConvo()
	},

	watch: {
		cid () {
			this.loadConvo()
		},
	},

	render () {
		if (this.error) return this.renderError()
		if (this.loading || this.creating) return <Spinner static mode="blue" size="120" center />
		let events = sb.map(store.listEvents(this.cid))
		events = sb.orderBy(events, 'created', 'asc')

		if (sb.size(events) === 0) {
			return (
				<div ref="body" class="widget-body--events-container">
					<div class="widget-body--empty">
						<div class="widget-body--empty-icon"></div>
						<div class="widget-body--empty-text">{this.$t('empty_convo_text')}</div>
					</div>
					<PoweredBy />
				</div>
			)
		}

		let convo = store.matchConvo(this.cid)
		events = sb.map(events, ev => ({ ev: ev }))
		processEvents(convo, events)

		let $events = sb.map(events, ev => (
			<Event vOn:formSubmit={this.onFormSubmit} ref={'event.' + ev.ev.id} event={ev} key={ev.ev.id} />
		))

		return (
			<div ref="body" class="widget-body--events-container">
				<div class="widget-body--events">{$events}</div>
				<PoweredBy />
			</div>
		)
	},

	methods: {
		renderError () {
			let $tryAgainBtn = (
				<a href="#" vOn:click={this.loadConvo}>
					{this.$t('try_again')}
				</a>
			)
			if (this.loading) $tryAgainBtn = <Spinner size="16" mode="blue" />
			return (
				<div class="widget-body--events-container widget-body--events-container__error">
					<img src={convoemptyimg} />
					<div class="widget_body__events__error_msg">{this.$t('load_convo_error')}</div>
					<div class="widget_body__events__error_retry">{$tryAgainBtn}</div>
				</div>
			)
		},
		onFormSubmit () {
			this.$emit('formSubmit')
		},

		focus () {
			let events = store.listEvents(this.cid)
			events = sb.orderBy(sb.map(events), 'created', 'desc')
			// find first msg_sent event of agent
			var last_agent_sent
			for (let ev of events) {
				if (sb.get(ev, 'type') !== 'message_sent') continue
				if (sb.get(ev, 'by.type') === 'user') continue
				last_agent_sent = ev
				break
			}

			if (sb.get(last_agent_sent, 'by.type') === 'user') last_agent_sent = null

			let attachments = sb.get(last_agent_sent, 'data.message.attachments', [])
			let pendingForms = sb.filter(attachments, att => {
				if (!att) return false
				if (att.type !== 'form' && att.type !== 'ask_info_form') return false
				var form = att.form
				if (!form) return false
				var state = sb.parseJSON(form.state) || {}
				if (!state.require_finished && att.type !== 'ask_info_form') return false
				if (form._submitted) return false
				return true
			})

			if (sb.size(pendingForms) > 0) {
				this.$refs['event.' + last_agent_sent.id].focus()
			}
		},

		onEvent (newev) {
			if (sb.convoOfEv(newev) !== this.cid) return
			let isBottom = this.isBottom()
			var byme = false
			if (sb.get(newev, 'type') === 'message_sent' && newev.id === sb.getMsgField(newev, 'idempotency')) byme = true
			// scroll to bottom when message is sent by me
			// auto scroll to bottom on new message when we are at the bottom
			if (byme || isBottom) this.scrollToBottom()
		},

		async loadConvo () {
			if (!this.cid) return
			// load msg
			this.lastContentOffsetY = 0
			let events = store.listEvents(this.cid)
			if (sb.size(events) === 0) {
				let cid = this.cid
				this.loading = true
				let { error } = await store.fetchMoreEvents(cid)
				this.loading = false
				if (cid !== this.cid) return // out dated
				if (error) {
					this.error = true
					return
				}
			}
			store.fetchMoreEvents(this.cid)

			this.error = false
			this.scrollToBottom()
		},

		isBottom () {
			let $container = this.$refs.body
			if (!$container) return false
			return $container.scrollHeight < $container.scrollTop + $container.offsetHeight + 50
		},

		scrollToBottom () {
			this.$nextTick(() => {
				this.$nextTick(() => {
					const $div = this.$refs.body
					if ($div) $div.scrollTop = $div.scrollHeight
				})
			})
			setTimeout(() => {
				const $div = this.$refs.body
				if ($div) $div.scrollTop = $div.scrollHeight
			}, 200)
		},
	},
}

// [{ev: {}, mode: 'time'}]
//_mode = time
//_mode = lead
function processEvents (convo, events) {
	if (events.length < 1) return

	// show time for the first msg sent
	// insert time
	for (var i = 1; i < events.length; i++) {
		let curEvent = events[i]
		let lastEvent = events[i - 1]

		if (visibleEvent(curEvent.ev)) {
			let elapsedSec = sb.unixSec(curEvent.ev.created) - sb.unixSec(lastEvent.ev.created)
			if (elapsedSec > 120) curEvent.show_time = true // 2 mins
		}
	}

	for (var i = 1; i < events.length; i++) {
		let curEvent = events[i]
		if (curEvent.ev.type === 'message_sent') {
			curEvent.show_time = true
			break
		}
	}

	// insert lead
	for (var i = 1; i < events.length; i++) {
		let curEvent = events[i]
		let prevEvent = events[i - 1]

		if (curEvent.ev.type === 'message_sent') {
			curEvent.mode = 'lead'
			if (prevEvent.ev.type === 'message_sent' && sb.get(prevEvent, 'ev.by.id') === sb.get(curEvent, 'ev.by.id')) {
				curEvent.mode = 'follow'
			}
			continue
		}
	}

	let userids = sb.usersOfConvo(convo)
	// find last msg by me
	let lastSentOrSeenByUser = 0
	for (var i = events.length - 1; i >= 0; i--) {
		lastSentOrSeenByUser = i
		if (userids.includes(sb.get(events[i], 'ev.by.id'))) break

		let userseen = sb.find(
			sb.get(events[i], 'ev.data.message.pongs'),
			p => p.type === 'seen' && userids.includes(p.member_id),
		)
		if (userseen) break
	}

	for (var i = lastSentOrSeenByUser + 1; i < events.length; i++) {
		// console.log("EEEEEEEEEEEEE", lo.get(events[i], 'ev'))
	}
	//let myid = store.me().id
	//for (var i = 0; i < lastSentOrSeenByUser + 1; i++) {
	//if (sb.get(events[i], 'ev.by.id') === myid) {
	//events[i].seen = true
	//}
	//}
}

function visibleEvent (ev) {
	let type = sb.get(ev, 'type')
	return (
		type === 'conversation_joined' ||
		type === 'conversation_left' ||
		type === 'message_sent' ||
		type === 'conversation_state_updated'
	)
}
